export const CampaignMessageLatestTestSendStageOutcome = {
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  RETRIED: "RETRIED",
  NOT_RUN: "NOT_RUN",
  PENDING: "PENDING",
} as const;

export type CampaignMessageLatestTestSendStageOutcome =
  (typeof CampaignMessageLatestTestSendStageOutcome)[keyof typeof CampaignMessageLatestTestSendStageOutcome];

/** Pipeline stage ids from latest_test_results (matches backend TestSendResultsManagement::SendingStage). */
export const CampaignMessageLatestTestSendStage = {
  BRAZE: "BRAZE",
  PROVIDER: "PROVIDER",
  USER_DEVICE: "USER_DEVICE",
} as const;

export type CampaignMessageLatestTestSendStage =
  (typeof CampaignMessageLatestTestSendStage)[keyof typeof CampaignMessageLatestTestSendStage];

export interface CampaignMessageLatestTestResultFailureReason {
  title: string;
  error_code?: string | null;
  details?: unknown;
  provider?: string | null;
  channel?: string | null;
  /** True when the failure outcome indicates retry attempts were exhausted. */
  exhausted_retries?: boolean;
}

export interface CampaignMessageLatestTestResultStage {
  id: CampaignMessageLatestTestSendStage;
  label: string;
  stage_outcome: CampaignMessageLatestTestSendStageOutcome;
  failure_reason?: CampaignMessageLatestTestResultFailureReason;
}

export interface CampaignMessageLatestTestResultRun {
  /** Unix timestamp when the run finished; null while the latest attempt is still in progress. */
  finished_at: number | null;
  /** Processing-ledger channel id for this run (e.g. `whats_app`). */
  channel?: string;
  stages: CampaignMessageLatestTestResultStage[];
}

export interface CampaignMessageLatestTestResultUser {
  user_id: string;
  user_first_name: string;
  runs: CampaignMessageLatestTestResultRun[];
}

/**
 * Response from GET .../latest_test_results.
 * `results` lists each recipient in the latest test-send dispatch with pre-computed runs and stages.
 */
export interface CampaignMessageLatestTestResultsResponse {
  campaign_id?: string;
  message_variation_id?: string;
  results: CampaignMessageLatestTestResultUser[];
}
